"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = Checkbox;
exports.COMPONENT_NAME = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _gerenciatdUtils = require("@bit/gerenciatd.utils.hooks-utils");

var _gerenciatdUtils2 = require("@bit/gerenciatd.utils.metrics");

require("./Checkbox.scss");

var _jsxRuntime = require("react/jsx-runtime");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

const COMPONENT_NAME = 'Checkbox';
exports.COMPONENT_NAME = COMPONENT_NAME;

function Checkbox({
  name,
  value,
  label,
  nodeLabel,
  onChange,
  defaultValue,
  formSkeletonProps,
  error,
  className,
  required,
  taggingInfo
}) {
  const {
    submitTries,
    activateFormElement,
    deactivateFormElement,
    validateFormElement,
    validateForm
  } = _objectSpread({}, formSkeletonProps);

  (0, _gerenciatdUtils.useFormSkeletonSubscribe)(activateFormElement, deactivateFormElement);
  const prevSubmitTries = (0, _gerenciatdUtils.usePreviousConditioned)(submitTries, validateForm);
  const [checked, setChecked] = (0, _react.useState)(defaultValue);
  const [validationError, setValidationError] = (0, _react.useState)('');
  (0, _react.useEffect)(() => {
    if (checked) {
      setValidationError('');
    }

    if (onChange) {
      onChange(!!checked, name, value);
    }
  }, [checked]);
  (0, _react.useEffect)(() => {
    setValidationError(error);
  }, [error]);
  (0, _react.useEffect)(() => {
    if (formSkeletonProps) {
      let validationObj = {};

      if (prevSubmitTries !== submitTries && submitTries > 0) {
        if (!checked && required) {
          validationObj = {
            validated: false,
            errorMsg: 'Por favor, rellena este campo'
          };
        } else {
          validationObj = {
            validated: true,
            errorMsg: ''
          };
        }

        setValidationError(validationObj.errorMsg);
        validateFormElement(validationObj);
      }
    }
  }, [submitTries, prevSubmitTries]);

  const handleOnChange = e => {
    setChecked(e.target.checked);

    const finalTaggingInfo = _objectSpread(_objectSpread({}, taggingInfo), {}, {
      componentName: taggingInfo.componentName || COMPONENT_NAME,
      componentVariation: taggingInfo.componentVariation || 'all',
      componentProduct: taggingInfo.componentProduct || '',
      componentContent: taggingInfo.componentContent || `checkbox-${name}-${e.target.checked ? 'marcar' : 'desmarcar'}`
    });

    (0, _gerenciatdUtils2.sendCMSEvent)(finalTaggingInfo);
  };

  const checkboxLabel = label || nodeLabel;
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    className: `CheckboxWrapper ${className}`,
    children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("label", {
      className: "label",
      htmlFor: name,
      children: [checkboxLabel && /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        className: "labelText",
        children: checkboxLabel
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("input", {
        value: value,
        name: name,
        id: name,
        type: "checkbox",
        checked: !!checked,
        onChange: handleOnChange
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
        className: `checkmark ${validationError ? 'error' : ''}`
      })]
    }), validationError && /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      className: "error",
      children: validationError || '\u00A0'
    })]
  });
}

Checkbox.propTypes = {
  /**
  * {
  *  "info": "Nombre que tomará el elemento en el DOM",
  *  "kind": "both",
  *  "beautifulName": "Name"
  * }
  */
  name: _propTypes.default.string.isRequired,

  /**
   * {
   *  "info": "Función ejecutada al marcar o desmarcar el checkBox ",
   *  "kind": "both",
   *  "beautifulName": "onChange"
   * }
   */
  onChange: _propTypes.default.func,

  /**
   * {
   *  "info": "Define el contenido que hará las funciones de label",
   *  "kind": "both",
   *  "beautifulName": "Etiqueta nodo"
   * }
   */
  nodeLabel: _propTypes.default.node,

  /**
   * {
   *  "info": "Texto que aparecerá como label del checkBox",
   *  "kind": "both",
   *  "beautifulName": "Etiqueta"
   * }
   */
  label: _propTypes.default.string,

  /**
   * {
   *  "info": "Define la clase CSS custom que se aplicará al componente",
   *  "kind": "both",
   *  "beautifulName": "ClassName"
   * }
   */
  className: _propTypes.default.string,

  /**
   * {
   *  "info": "Valor enviado del checkBox",
   *  "kind": "both",
   *  "beautifulName": "Valor"
   * }
   */
  value: _propTypes.default.string,

  /**
   * {
   *  "info": "Marca o desmarca por defecto del checkBox",
   *  "kind": "both",
   *  "beautifulName": "ValorPorDefecto"
   * }
   */
  defaultValue: _propTypes.default.bool,

  /**
  * {
  *  "info": "Propiedades de formSkeleton necesarias para su integración con este componente",
  *  "kind": "both",
  *  "beautifulName": "formSkeletonProps"
  * }
  */
  formSkeletonProps: _propTypes.default.shape({
    submitTries: _propTypes.default.number.isRequired,
    validationTries: _propTypes.default.number.isRequired,
    activateFormElement: _propTypes.default.func.isRequired,
    deactivateFormElement: _propTypes.default.func.isRequired,
    validateFormElement: _propTypes.default.func.isRequired,
    validateForm: _propTypes.default.bool.isRequired
  }),

  /**
   * {
   *  "info": "Define si es obligatorio marcar el checkBox o no",
   *  "kind": "both",
   *  "beautifulName": "Requerido"
   * }
   */
  required: _propTypes.default.bool,

  /**
   * {
   *  "info": "Error a mostrar forzado desde el padre",
   *  "kind": "both",
   *  "beautifulName": "Error"
   * }
   */
  error: _propTypes.default.string
};
Checkbox.defaultProps = {
  value: '',
  label: '',
  defaultValue: false,
  formSkeletonProps: null,
  error: '',
  className: '',
  required: false
};

//# sourceMappingURL=index.js.map